import React from "react";
import ReactDOM from "react-dom/client";

import { Loading } from "@/components/molecules/Loading";

import QuoteDrawer from "./QuoteDrawer";
import "./main.css";
import { DrawerEvent } from "./quote/eventEnums";

const rootElement = document.querySelector("#quote-root");

if (rootElement) {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <React.Suspense fallback={<Loading />}>
        <QuoteDrawer />
      </React.Suspense>
    </React.StrictMode>,
  );
}

const initOnlineBooking = () => {
  const buttons = document.querySelectorAll<HTMLButtonElement>(
    "[role='button'][data-target='#quote-drawer']",
  );

  if (buttons.length) {
    buttons.forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const { packageId } = button.dataset;
        if (packageId) {
          window.postMessage({
            eventType: DrawerEvent.OPEN_DRAWER,
            event: { packageId: button.dataset.packageId },
          });
        }
      });
    });
  }
};

initOnlineBooking();
